import React from 'react';
import PropTypes from 'prop-types';

/**
 * renders a group of radio options under a legend, used for yes/no style form questions
 * @param legend - question shown above the options
 * @param name - name shared by every radio input in the group
 * @param value - currently selected option value
 * @param onChange - called with the newly selected option value
 * @param options - list of { value, label } options to render
 * @param required - whether to show the required asterisk next to the legend
 */
export default function RadioFieldset({
  legend,
  name,
  value,
  onChange,
  options,
  required = true
}) {
  return (
    <fieldset className='space-y-2 border-0 p-0 min-w-0'>
      <legend className='block text-sm font-semibold text-black mb-1.5'>
        {legend}
        {required && <span className='text-semantic-danger'> *</span>}
      </legend>
      <div className='flex flex-wrap gap-x-6 gap-y-2'>
        {options.map(opt => (
          <label
            key={opt.value}
            className='inline-flex items-center gap-2 cursor-pointer text-sm text-black'
          >
            <input
              type='radio'
              name={name}
              value={opt.value}
              checked={value === opt.value}
              onChange={() => onChange(opt.value)}
              className='size-4 accent-secondary-darkest shrink-0'
            />
            <span>{opt.label}</span>
          </label>
        ))}
      </div>
    </fieldset>
  );
}

RadioFieldset.propTypes = {
  legend: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({ value: PropTypes.string, label: PropTypes.string })
  ).isRequired,
  required: PropTypes.bool
};
